let Promise = require('bluebird');
let Vue = require('vue');

module.exports = () => new Promise((resolve, reject) => {
    Vue.component("menu_customers_count", {
        template: `
            <div class="">
                
            </div>
        `,
        props: ["alias", "data"]
    });

    resolve();
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/widgets/menu_customers_count.js